import styled from 'styled-components'

export const ModalTitle = styled.div`
	padding: 0 24px;
	font-weight: 600;
	font-size: 40px;
	line-height: 48px;
	color: #000000;
`

export const ModalBody = styled.div`
	padding: 10px 28px;
`
